
export const environment = {
   production: true,
   apiRoot: 'https://api-wls-phonder.attekmi.co/api',
   appRoot: 'https://api-wls-phonder.attekmi.co',
   isEnableErrorHandler: 'true',
   apiForLogger: 'https://api-wls-phonder.attekmi.co/api/log/error',
   echoKey: 'phonder',
   echoHost: 'api-wls-phonder.attekmi.co',
   echoPort: '443',
   echoHttps: 'true',

};